import React, { useEffect, useState } from "react";
import { useIframeUrlMutation } from "../../app/services/DashBoard/adminDashBoardApi";
import { formatISO } from "date-fns";
import { ReportFrame } from "./ReportFrame";

const MetaBaseDashBoardFour = () => {
  const [iframeUrl, setIframeUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [iframeUrlApi] = useIframeUrlMutation();
  const fetchIframeUrl = async (withFilter = false) => {
    setLoading(true);
    setError("");
    try {
      const requestPayload = {
        questionId: 42,
        params: {
          StartDate:
            withFilter && startDate
              ? `${formatISO(startDate, { representation: "date" })} 00:00:00`
              : null,
          EndDate:
            withFilter && endDate
              ? `${formatISO(endDate, { representation: "date" })} 00:00:00`
              : null,
        },
        expMinutes: 10,
        bordered: true,
        titled: true,
      };

      const response = await iframeUrlApi(requestPayload).unwrap();
      setIframeUrl(response.iframeUrl);
    } catch (err) {
      console.error(err);
      setError("Failed to fetch iframe URL");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchIframeUrl(false);
  }, []);

  const resetForm = () => {
    setStartDate(null);
    setEndDate(null);
    fetchIframeUrl(false);
  };

  return (
    <div style={{ padding: "20px", position: "relative" }}>
      <button
        onClick={resetForm}
        class="btn success-btn reload-btn"
        disabled={loading}
        style={{
          cursor: loading ? "not-allowed" : "pointer",
        }}
      >
        {loading ? "Loading..." : "Reload Report"}
      </button>

      <div className="iframe-card">
        <div>
          <label style={{ display: "block", marginBottom: "4px" }}>
            Start Date
          </label>
          <input
            type="date"
            value={
              startDate ? formatISO(startDate, { representation: "date" }) : ""
            }
            onChange={(e) =>
              setStartDate(e.target.value ? new Date(e.target.value) : null)
            }
            style={{
              padding: "6px",
              borderRadius: "4px",
              border: "1px solid #ccc",
            }}
          />
        </div>

        <div>
          <label style={{ display: "block", marginBottom: "4px" }}>
            End Date
          </label>
          <input
            type="date"
            value={
              endDate ? formatISO(endDate, { representation: "date" }) : ""
            }
            onChange={(e) =>
              setEndDate(e.target.value ? new Date(e.target.value) : null)
            }
            style={{
              padding: "6px",
              borderRadius: "4px",
              border: "1px solid #ccc",
            }}
          />
        </div>
        <button
          onClick={() => fetchIframeUrl(true)}
          disabled={loading}
          style={{
            backgroundColor: "#ff8c00",
            color: "white",
            border: "none",
            padding: "8px 16px",
            borderRadius: "6px",
            cursor: loading ? "not-allowed" : "pointer",
          }}
        >
          {loading ? "Loading..." : "Fetch"}
        </button>
      </div>

      {loading && <p>Loading report...</p>}
      {error && <p style={{ color: "red" }}>{error}</p>}

      {iframeUrl && (
        <ReportFrame url={iframeUrl} />
      )}
    </div>
  );
};

export default MetaBaseDashBoardFour;
